import { render, staticRenderFns } from "./vendadireta.vue?vue&type=template&id=2faf5ff8"
import script from "./vendadireta.vue?vue&type=script&lang=js"
export * from "./vendadireta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports